
export const RESULT_STATUS = {
  "START_LIST": 1,
  "LIVE": 2,
  "INTERMEDIATE": 3,
  "UNCONFIRMED": 4,
  "UNOFFICIAL": 5,
  "OFFICIAL": 6,
  "PARTIAL": 7,
  "PROTESTED": 8,
  "PROVISIONAL": 9
};

export const SCHEDULE_STATUS = {
  "UNSCHEDULED": 1,
  "SCHEDULED": 2,
  "GETTING_READY": 3,
  "RUNNING": 4,
  "FINISHED": 5,
  "DELAYED": 6,
  "INTERRUPTED": 7,
  "CANCELLED": 8,
  "SCHEDULED_BREAK": 9,
  "POSTPONED": 10,
  "RESCHEDULED": 11
};

/**
     * Get the result status as integer value used in wrs
     * 
     * @param type of the static variable name
     * @return an int corresponding to a static value
     */

export function getResultStatusAsInteger(sStatus) {
  sStatus = sStatus === null ? '' : sStatus;
  switch (sStatus) {
    case "START_LIST":
      return RESULT_STATUS.START_LIST;
    case "LIVE":
      return RESULT_STATUS.LIVE;
    case "INTERMEDIATE":
      return RESULT_STATUS.INTERMEDIATE;
    case "UNCONFIRMED":
      return RESULT_STATUS.UNCONFIRMED;
    case "UNOFFICIAL":
      return RESULT_STATUS.UNOFFICIAL;
    case "OFFICIAL":
      return RESULT_STATUS.OFFICIAL;
    case "PARTIAL":
      return RESULT_STATUS.PARTIAL;
    case "PROTESTED":
      return RESULT_STATUS.PROTESTED;
    default:
      return -1;
  }
}

export function getResultStatusAsString(sStatus) {
  switch (sStatus) {
    case RESULT_STATUS.START_LIST:
      return "START_LIST";
    case RESULT_STATUS.LIVE:
      return "LIVE";
    case RESULT_STATUS.INTERMEDIATE:
      return "INTERMEDIATE";
    case RESULT_STATUS.UNCONFIRMED:
      return "UNCONFIRMED";
    case RESULT_STATUS.UNOFFICIAL:
      return "UNOFFICIAL";
    case RESULT_STATUS.OFFICIAL:
      return "OFFICIAL";
    case RESULT_STATUS.PARTIAL:
      return "PARTIAL";
    case RESULT_STATUS.PROTESTED:
      return "PROTESTED";
    default:
      return '';
  }
}

export function getScheduleStatusAsInteger(sStatus) {
  //sStatus = (sStatus === null) ? 0 : sStatus;
  switch (sStatus) {
    case "UNSCHEDULED":
      return SCHEDULE_STATUS.UNSCHEDULED;
    case "SCHEDULED":
      return SCHEDULE_STATUS.SCHEDULED;
    case "GETTING_READY":
      return SCHEDULE_STATUS.GETTING_READY;
    case "RUNNING":
      return SCHEDULE_STATUS.RUNNING;
    case "FINISHED":
      return SCHEDULE_STATUS.FINISHED;
    case "DELAYED":
      return SCHEDULE_STATUS.DELAYED;
    case "INTERRUPTED":
      return SCHEDULE_STATUS.INTERRUPTED;
    case "CANCELLED":
      return SCHEDULE_STATUS.CANCELLED;
    case "SCHEDULED_BREAK":
      return SCHEDULE_STATUS.SCHEDULED_BREAK;
    case "POSTPONED":
      return SCHEDULE_STATUS.POSTPONED;
    case "RESCHEDULED":
      return SCHEDULE_STATUS.RESCHEDULED;
    default:
      return 0; // we're using this value in Status component to know if we're in a subunit without scheduleStatus but resultsStats
  }
}


export function getScheduleStatusAsString(sStatus) {
  switch (sStatus) {
    case SCHEDULE_STATUS.UNSCHEDULED:
      return "UNSCHEDULED";
    case SCHEDULE_STATUS.SCHEDULED:
      return "SCHEDULED";
    case SCHEDULE_STATUS.GETTING_READY:
      return "GETTING_READY";
    case SCHEDULE_STATUS.RUNNING:
      return "RUNNING";
    case SCHEDULE_STATUS.FINISHED:
      return "FINISHED";
    case SCHEDULE_STATUS.DELAYED:
      return "DELAYED";
    case SCHEDULE_STATUS.INTERRUPTED:
      return "INTERRUPTED";
    case SCHEDULE_STATUS.CANCELLED:
      return "CANCELLED";
    case SCHEDULE_STATUS.SCHEDULED_BREAK:
      return "SCHEDULED_BREAK";
    case SCHEDULE_STATUS.POSTPONED:
      return "POSTPONED";
    case SCHEDULE_STATUS.RESCHEDULED:
      return "RESCHEDULED";
    default:
      return "UNSCHEDULED";
  }
}

export function isLiveStatus(sStatus) {
  let value = isNaN(sStatus) ? getResultStatusAsInteger(sStatus) : sStatus;
  return (
    (value === RESULT_STATUS.INTERMEDIATE || value === RESULT_STATUS.LIVE)
  )
}

export function isLessLiveStatus(sStatus) {
  if (sStatus === undefined) { sStatus = 0 }
  let value = isNaN(sStatus) ? getResultStatusAsInteger(sStatus) : sStatus;
  return (

    (value < RESULT_STATUS.LIVE)
  )
}

export function isStartListStatus(sStatus) {
  let value = isNaN(sStatus) ? getResultStatusAsInteger(sStatus) : sStatus;
  return (
    (value === RESULT_STATUS.START_LIST)
  )
}

export function isMoreStartListStatus(sStatus) {
  if (sStatus === undefined) { sStatus = 0 }
  let value = isNaN(sStatus) ? getResultStatusAsInteger(sStatus) : sStatus;
  return (
    (value > RESULT_STATUS.START_LIST)
  )
}

export function isFinishedStatus(sStatus) {
  let value = isNaN(sStatus) ? getResultStatusAsInteger(sStatus) : sStatus;
  return (
    (value === RESULT_STATUS.UNCONFIRMED || value === RESULT_STATUS.UNOFFICIAL || value === RESULT_STATUS.OFFICIAL || value === RESULT_STATUS.PROTESTED || value === RESULT_STATUS.PARTIAL)
  )
}



// Schedule Status 
export function scheduleIsRunningStatus(sStatus) {
  let value = isNaN(sStatus) ? getScheduleStatusAsInteger(sStatus) : sStatus;
  return (
    (value === SCHEDULE_STATUS.GETTING_READY || value === SCHEDULE_STATUS.RUNNING || value === SCHEDULE_STATUS.SCHEDULED_BREAK)
  )
}

export function scheduleIsHigherUnScheduled(sStatus) {
  let value = isNaN(sStatus) ? getScheduleStatusAsInteger(sStatus) : sStatus;
  return (
    (value > SCHEDULE_STATUS.UNSCHEDULED)
  )
}

export function scheduleIsHigherScheduled(sStatus) {
  let value = isNaN(sStatus) ? getScheduleStatusAsInteger(sStatus) : sStatus;
  return (
    (value > SCHEDULE_STATUS.SCHEDULED)
  )
}

export function scheduleIsHigherGettingReady(sStatus) {
  let value = isNaN(sStatus) ? getScheduleStatusAsInteger(sStatus) : sStatus;
  return (
    (value > SCHEDULE_STATUS.GETTING_READY)
  )
}


export function scheduleIsHigherRunning(sStatus) {
  let value = isNaN(sStatus) ? getScheduleStatusAsInteger(sStatus) : sStatus;
  return (
    (value > SCHEDULE_STATUS.RUNNING)
  )
}
